import React from "react"
import SeoLandingPage from "./SeoLandingPage"
import { SEO_KEYWORDS_EXTRA } from "../../seo/extraKeywords"

export default function BedAdmissionOdisha() {
  return (
    <SeoLandingPage
      path="/b-ed-admission-odisha"
      title="Best B.Ed Institute Odisha | Top Admission Counselling & Coaching 2026"
      description="Top B.Ed admission institute support across Odisha: counselling, coaching, forms, documents, books and online classes—with trusted Bhadrak office support for Bhadrak, Balasore, Karanjia & more."
      keywords={`best B.Ed institute Odisha, B.Ed admission Bonth, B.Ed Andapur, B.Ed Chhenapadi, B.Ed Thakurmunda Mayurbhanj, top B.Ed institute Odisha, B.Ed admission Odisha, B.Ed coaching Odisha, B.Ed college Odisha, B.Ed private college Odisha, B.Ed consultancy Odisha, teacher training Odisha, B.Ed Bhadrak Balasore Karanjia, BEd admission 2026 Odisha, ${SEO_KEYWORDS_EXTRA}`}
      h1="Best B.Ed Admission Support in Odisha — Counselling + Coaching"
      intro="If you are searching for the best B.Ed institute in Odisha or top B.Ed admission guidance, we help from enquiry to confirmation: counselling, eligibility support, admission processing, books and online coaching—with local office support in Bhadrak for nearby districts."
      bullets={[
        "B.Ed admission counselling for Odisha students",
        "Eligibility & document checklist support",
        "Form fill-up and admission processing assistance",
        "Books / study material distribution (offline)",
        "Online coaching/classes for B.Ed preparation",
        "Support via call/WhatsApp + in-office guidance (Bhadrak)",
      ]}
      areaServed={[
        { "@type": "State", name: "Odisha" },
        { "@type": "City", name: "Bhadrak" },
        { "@type": "Place", name: "Bonth" },
        { "@type": "Place", name: "Andapur" },
        { "@type": "Place", name: "Chhenapadi" },
        { "@type": "Place", name: "Thakurmunda" },
        { "@type": "City", name: "Balasore" },
        { "@type": "City", name: "Baripada" },
        { "@type": "City", name: "Mayurbhanj" },
        { "@type": "City", name: "Karanjia" },
      ]}
      faqs={[
        {
          q: "Is coaching included with admission support?",
          a: "Yes. We provide admission counselling plus coaching support (online classes and study material guidance) based on your course requirements.",
        },
        {
          q: "Do you help if I search “B.Ed private institute near me” or “B.Ed coaching center near me” in Odisha?",
          a: "Yes. We support students across Odisha through counselling and online coaching, with offline office support available in Bhadrak.",
        },
        {
          q: "Do you have an office in Odisha?",
          a: "Yes. Our office is in Bhadrak where students can visit for counselling, document support and book distribution.",
        },
        {
          q: "What documents are usually required for B.Ed admission?",
          a: "Typically you need ID proof, photo, academic certificates/mark sheets and other documents as per the admission process. We share an exact checklist during counselling.",
        },
      ]}
    />
  )
}

